import type { Suit } from '@mendikot/engine';

/** Vector suit shapes (text glyphs like ♥ can render as emoji on phones). 100×100 box. */
export function SuitShape({ suit }: { suit: Suit }) {
  switch (suit) {
    case 'H':
      return (
        <path d="M50 90C22 66 5 50 5 31 5 17 16 7 29 7c9 0 17 5 21 13 4-8 12-13 21-13 13 0 24 10 24 24 0 19-17 35-45 59z" />
      );
    case 'D':
      return <path d="M50 4l38 46-38 46-38-46z" />;
    case 'S':
      return (
        <path d="M50 4c13 19 45 36 45 58 0 14-11 24-24 24-8 0-14-4-18-9 1 9 5 15 13 19H34c8-4 12-10 13-19-4 5-10 9-18 9C16 86 5 76 5 62 5 40 37 23 50 4z" />
      );
    case 'C':
      return (
        <g>
          <circle cx="50" cy="28" r="20" />
          <circle cx="27" cy="57" r="20" />
          <circle cx="73" cy="57" r="20" />
          <path d="M45 50c0 22-3 34-13 46h36C58 84 55 72 55 50z" />
        </g>
      );
  }
}

export function suitColor(suit: Suit, fourColor: boolean): string {
  if (fourColor) {
    return {
      S: 'var(--c-card-ink)',
      H: 'var(--c-card-red)',
      D: 'var(--c-card-blue)',
      C: 'var(--c-card-green)',
    }[suit];
  }
  return suit === 'H' || suit === 'D' ? 'var(--c-card-red)' : 'var(--c-card-ink)';
}

/** Suit glyph for UI chrome (light on dark), sized like an icon. */
export function SuitIcon({
  suit,
  size = 16,
  color,
  className,
  title,
}: {
  suit: Suit;
  size?: number;
  color?: string;
  className?: string;
  title?: string;
}) {
  const fill = color ?? (suit === 'H' || suit === 'D' ? '#ff6b6b' : 'currentColor');
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      fill={fill}
      className={className}
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      <SuitShape suit={suit} />
    </svg>
  );
}
